import type { ForwardedRef, PropsWithChildren } from "react";
import React, { memo } from "react";
import type { SelectlistVariants } from "./Selectlist.styles";
import SelectlistVariant from "./Selectlist.styles";
import * as Styles from "./Selectlist.styles";
import Icon from "../Icon";
import { useUscLabel } from "../../../../utils/labels";
import { SrOnly } from "../utils/Accessibility.styles";

export type SelectlistVariantsType = keyof typeof SelectlistVariants;

type SelectlistType = {
    variant: SelectlistVariantsType;
    selectlistTitle?: string;
    listboxHeadingTitle?: string;
    show?: boolean;
    name?: string;
    dropdownRef?: ForwardedRef<HTMLDivElement>;
    onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
};

const SelectList: React.FC<PropsWithChildren<SelectlistType>> = (props) => {
    const { variant, selectlistTitle, listboxHeadingTitle, show, name, dropdownRef, onClick, children } = props;
    const searchTaxLocationLabel = useUscLabel("uscAriaSearchTaxLocationLabel");
    const currentTaxLocationLabel = useUscLabel("uscAriaButtonCurrentTaxLocation");
    return (
        <SelectlistVariant variant={variant} ref={dropdownRef}>
            <Styles.Button
                type="button"
                onClick={onClick}
                aria-controls={name}
                aria-expanded={show}
                aria-label={searchTaxLocationLabel}
            >
                <SrOnly>{currentTaxLocationLabel}</SrOnly>
                {selectlistTitle}
                <Icon variant="chevron-down" />
            </Styles.Button>
            <Styles.Listbox id={name} role="region" tabIndex={-1}>
                <Styles.ListboxHeader>
                    {listboxHeadingTitle}
                    <Icon variant="chevron-up" />
                </Styles.ListboxHeader>
                {children}
            </Styles.Listbox>
        </SelectlistVariant>
    );
};

export default memo(SelectList);
